import { IProps as IFeatureTestimonial } from 'marketing-site/src/library/elements/FeatureTestimonial'
import { IFeatureSpotlightWithTestimonial as IContentfulFeatureSpotlightTestimonial } from 'marketing-site/@types/generated/contentful'

export function transformFeatureTestimonial({
  fields,
}: IContentfulFeatureSpotlightTestimonial): IFeatureTestimonial {
  return {
    quote: fields.testimonialQuote,
    name: fields.testimonialName,
    jobTitle: fields.testimonialJobTitle,
    companyName: fields.testimonialCompanyName,
    companyLogo: fields.testimonialCompanyLogo?.fields.file.url,
  }
}
